import { UPLOAD_TYPE } from "./define";
import * as utils from "./utils";
import { getIpInfo } from "./ip";
import { getFingerPrint } from "./finger";
import time from "./time";
import { getSessionInfo } from "./sessionId";
import { updateCommonParamsInfo, getCommonParamsInfo } from "./commonParam";
const excUpload = (url, data, useGet = false) => {
  if (
    navigator.sendBeacon &&
    Object.prototype.toString.call(navigator.sendBeacon) ==
      "[object Function]" &&
    !useGet
  ) {
    const params = new URLSearchParams();
    for (let key in data) {
      // post上报不需要编码
      params.append(key, String(data[key]));
    }
    navigator.sendBeacon(url, params);
  } else {
    let img = new Image();
    img.src = utils.getAjaxLink(url, data);
  }
};

const officialGuideUpload = async (data = {}) => {
  if (!Object.keys(data).length) return;
  let _time = time();
  let fingerTxt = await getFingerPrint();
  const ipInfo = await getIpInfo();
  const sessionInfo = getSessionInfo();
  const commonParamStorage = getCommonParamsInfo();
  let eventValue = "";
  const url = "https://gcollectsecond.octlib.com/sdkUIData/collectData";

  let updateParams = {
    gameId: data.gameId,
    loginAccount: data.loginAccount,
    uid: data.uid,
    roleName: data.roleName,
    roleId: data.roleId,
    serverId: data.serverId,
    packageName: data.packageName,
    devicePlate: data.devicePlate,
    cid: data.cid,
    scid: data.scid,
    language: data.language,
    pageId: data.pageId,
  };

  Object.keys(updateParams).forEach((key) => {
    if (updateParams[key] === null || updateParams[key] === undefined) {
      delete updateParams[key];
    }
  });

  if (Object.keys(updateParams).length) {
    updateCommonParamsInfo(updateParams);
  }

  if (data.eventValue) {
    eventValue = JSON.stringify(data.eventValue);
  }

  let params = {
    ptcode: utils.getPlatform(),
    game_id: data?.gameId || commonParamStorage?.gameId || utils.getGameId(), // 游戏ID
    page_type: "SDKGuide", // 上报日志类型
    page_id: data?.pageId || commonParamStorage?.pageId || "", // 站点标识
    url: window.location.href,
    title: document.title?.trim() || "",
    user_fingerprint: fingerTxt,
    session_id: sessionInfo?.sid || "",
    session_number: sessionInfo?.sount || "",
    uid: data?.uid || commonParamStorage?.uid || "",
    login_account: data?.loginAccount || commonParamStorage?.loginAccount || "",
    role_name: data?.roleName || commonParamStorage?.roleName || "",
    role_id: data?.roleId || commonParamStorage?.roleId || "",
    server_id: data?.serverId || commonParamStorage?.serverId || "",
    event_time: data?.pointTime || _time.pointTime,
    event_date: data?.pointDate || _time.pointDate,
    event_timestamp: data?.pointTimestamp || _time.pointTimestamp,
    os: utils.systemInfo,
    os_version: utils.getOsVersion(),
    device_type: utils.getOsModel(),
    ip: ipInfo?.ip || "",
    browser_version: utils.getBrowserVerson(),
    browser_type: utils.getBrowserName(),
    language: data?.language || commonParamStorage?.language || "",
    cid:
      data?.cid || commonParamStorage?.cid || utils.getUrlParams("cid") || "",
    scid:
      data?.scid ||
      commonParamStorage?.scid ||
      utils.getUrlParams("scid") ||
      "",
    browser_user_agent: encodeURIComponent(navigator.userAgent),
    logger: "平台前端",
    package_name:
      data?.packageName ||
      commonParamStorage?.packageName ||
      utils.getUrlParams("packageName") ||
      "",
    device_plate:
      data?.devicePlate ||
      commonParamStorage?.devicePlate ||
      utils.getUrlParams("devicePlate") ||
      "",
    event_name: data?.eventName || "", //事件名称
    event_is_first: data?.eventIsFirst || "", //事件首次行为
    event_type: data?.eventType || "", //事件类型
    event_reason: data?.eventReason || "", //事件原因
    event_value: eventValue || "", //事件值
  };
  excUpload(url, params);
};

export const getUploadFn = async (fnType) => {
  switch (fnType) {
    case UPLOAD_TYPE.officialGuide: {
      return officialGuideUpload;
    }
    default:
      return (data) => {
        console.log(data);
      };
  }
};
